<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 mt-5">
                <b-alert :variant="resultValidationType"
                       dismissible
                       :show="showResultValidation"
                       @dismissed="showResultValidation=false">
                  <h4 class="alert-heading" v-if="resultValidationType === 'success'">{{ session.language.allowed }}!</h4>
                  <h4 class="alert-heading" v-else>{{ session.language.denied }}!</h4>
                  <p v-if="wsError === null">
                      <strong>Punto de control: </strong>{{ pass.checkpointName }}<br/>
                      <strong>Visitante: </strong>{{ pass.visitorName }}<br/>
                      <strong>Placa: </strong>{{ pass.visitorPlate }}<br/>
                      <strong>Departamento: </strong>{{ pass.apartment }}<br/>
                      <strong>Edificio: </strong>{{ pass.building }}<br/>
                  </p>
                  <p v-else>
                    {{ wsError }}
                  </p>
                  <div class="row">
                      <div class="col-6">
                          <small>
                              <strong>Tipo de validación: </strong>
                              <span v-if="pass.offline">Offline</span>
                              <span v-else>Online</span>
                          </small>
                      </div>
                      <div class="col-6 text-right">
                          <small>
                              <strong>{{ pass.validationDate }}</strong>
                          </small>
                      </div>
                  </div>
              </b-alert>
            </div>
            <div class="col-md-6 mt-5">
                <b-img center src="/img/qr_image.gif" fluid alt="qr"></b-img>
                <form>
                    <div class="form-group mt-3">
                        <label for="qr"><strong>Código QR</strong></label>
                        <textarea
                            ref="qr"
                            class="form-control"
                            id="qr"
                            @input="validate"
                            v-model="qr"
                            :disabled="busy"
                        >
                        </textarea>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
  import debounce from 'debounce'
  import { mapActions } from 'vuex'
  import { check } from '@/services/apiLocalService'
  import io from "socket.io-client";
  import Config from "@/config/app.json";

  export default {
    name: 'check-fastpass',
    data () {
      return {
        qr: '',
        busy: false,
        showResultValidation: false,
        resultValidationType: 'success',
        wsError: null,
        lastValidatedCards: [],
        pass: {
          checkpointName: null,
          visitorName: null,
          visitorPlate: null,
          apartment: null,
          building: null,
          offline: false,
          date: null
        }
      }
    },
    mounted () {
      this.resetInput()
    },
    created () {
      this.listenWebSocketEvents()
    },
    methods: {
      listenWebSocketEvents () {
        const socket = io(`${Config.socketUrl}`)
        socket.on('checkResult', data => {
          if (!data.success) {
            this.showResultValidation = true
            this.resultValidationType = 'danger'
            this.wsError = data.error
            this.resetInput()
            return
          }

          this.pass.apartment = data.fastPass.apartment
          this.pass.building = data.fastPass.building
          this.pass.visitorName = data.fastPass.visitor.name
          this.pass.visitorPlate = data.fastPass.visitor.licensePlate
          this.pass.checkpointName = data.checkpoint.name
          this.pass.offline = data.fastPass.offline

          this.showResultValidation = true
          this.resultValidationType = 'success'

          this.resetInput()
        })
      },
      ...mapActions([
        'setSession'
      ]),
      validate: debounce(function () {
        if (this.busy) {
          this.resetInput()
          return
        }

        this.checkFastPass()
      }, 2000),
      async checkFastPass () {
        let data = null
        this.busy = true
        try {
          data = JSON.parse(this.qr)
          if (!data) {
            throw new Error('Invalid input')
          }

          if (!Object.keys(data).length) {
            this.resetInput()
            return
          }

          const result = await check(data, this.$route.params.checkPointId)

          this.resetInput()

          if (result.type === 'success') {
            this.displayValidationResponse(result.checkResult, result.type)
            return
          }

          this.displayValidationResponse({}, 'danger')
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err)
          this.resetInput()
        }
      },
      displayValidationResponse (data, type) {
        const cards = data.cards || []
        const visitorCard = cards.find(c => c.type === 'visitor')
        const generalCard = cards.find(c => c.type === 'general')
        this.pass.offline = data.offline
        this.pass.validationDate = data.validationDate

        this.showResultValidation = true
        this.resultValidationType = type
        if (visitorCard !== undefined) {
          this.pass.visitorName = visitorCard.name
          this.pass.visitorPlate = visitorCard.licensePlate
        }

        if (visitorCard !== undefined) {
          this.pass.apartment = generalCard.apartment
          this.pass.building = generalCard.building
        }
        this.resetInput()
      },
      resetInput () {
        this.qr = ''
        this.busy = false
        this.$nextTick(() => {
          if (this.$refs.qr) {
            this.$refs.qr.focus()
          }
        })
      },
    },
    computed: {
      session () {
        return this.$store.getters.session || { user: { email: null, token: null }, language: {} }
      }
    }
  }
</script>

<style>

</style>
